export const terminalAddress = [
  {
    address: '2500 Navy Way Terminal Island CA 90731',
    lat: 33.7258612,
    lng: -118.2499207,
  },
  {
    address: '389 Terminal Island Way Terminal CA 90731',
    lat: 33.7432549,
    lng: -118.2664088,
  },
  {
    address: '614 Terminal Way San Pedro CA 90731',
    lat: 33.7409584,
    lng: -118.2539878,
  },
  {
    address: '630 West Harry Bridges Blvd Wilmington CA 90744',
    lat: 33.7704523,
    lng: -118.2686751,
  },
  {
    address: '2050 John S Gibson BlvdSan Pedro CA 90731',
    lat: 33.7560558,
    lng: -118.2887177,
  },
  {
    address: '1521 Pier J Ave E Long Beach CA 90802',
    lat: 33.7421785,
    lng: -118.1897916,
  },
  {
    address: '855 Pier G Ave Long Beach CA 90802',
    lat: 33.7548146,
    lng: -118.2041158,
  },
  {
    address: '700 Pier A Plaza Long Beach CA 90813',
    lat: 33.7739937,
    lng: -118.2393644,
  },
  {
    address: '1320 Pier C St Long Beach CA 90813',
    lat: 33.7745035,
    lng: -118.2085504,
  },
  {
    address: '201 Pico Ave Long Beach CA 90802',
    lat: 33.76578620000001,
    lng: -118.2109531,
  },
  {
    address: '301 Mediterranean Way Long Beach CA 90802',
    lat: 33.7603501,
    lng: -118.2255246,
  },
  {
    address: '802 New Dock St San Pedro CA 90731',
    lat: 33.7547235,
    lng: -118.2558178,
  },
];

export const hasTerminalAddress = (payload) =>
  payload.some(
    ({
      location: { address: cAddress, lat: cLat, lng: cLng },
      exportLocation: { lat: eLat, lng: eLng },
    }) =>
      terminalAddress.find(
        ({ address: tAddress, lat: tLat, lng: tLng }) =>
          tAddress === cAddress ||
          (tLat === cLat && tLng === cLng) ||
          (tLat === eLat && tLng === eLng)
      )
  );

export const isTerminalAddress = (address, lat, lng) =>
  terminalAddress.find(
    ({ address: tAddress, lat: tLat, lng: tLng }) =>
      tAddress === address || (tLat === lat && tLng === lng)
  );
export const marketterminals = [
  {
    name: 'FL/MIAMI',
  },
  {
    name: 'GA/SAVANNAH',
  },
  {
    name: 'LA/LGB',
  },
  {
    name: 'SF/OAKLAND',
  },
  {
    name: 'NJ/NEWARK',
  },
  {
    name: 'TX/HOUSTON',
  },
  {
    name: 'BC/VANCOUVER',
  },
];

export const isInlandTerminal = async (terminal) => {
  const data = await marketterminals.filter((val) => val.name === terminal);
  return !!data.length;
};
